import { RichContent } from '@corratech/pylot-rich-content'
import React, { useEffect } from 'react'
import { useCmsBlocks } from '@pylot-data/hooks/cms/use-cms-blocks'
import { Layout } from '@components/common'
import { getStoreConfig } from '@config/hooks/useStoreConfig'
import { getCMSBlock } from '@components/common/CMSBlockConst/cms-block-util'
import { GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import { SEO, SEO_ENUMS } from '@components/seo'
import s from '@pagestyles/Cms.module.scss'

const REWARDS_PAGE_FAQ = 'rewards_page_faq'

declare global {
    interface Window {
        yotpoWidgetsContainer: {
            initWidgets: () => void
        }
    }
}

export const getStaticProps: GetStaticProps = async ({
    locale
}: GetStaticPropsContext) => {
    const config = getStoreConfig(locale)
    if (!config?.base?.yotpoLoyalty?.enabled) {
        return {
            notFound: true
        }
    }
    return {
        props: {
            widgetId: config.base.yotpoLoyalty.widget_ids?.rewardsPage,
            ...(await serverSideTranslations(locale!, ['common', 'account']))
        },
        revalidate: 14400
    }
}

export default function Rewards(props: { widgetId: string }): JSX.Element {
    const { toggleYotpoReviewPageWidget } = useAlfakherContext()

    const { items: CmsBlocks } = useCmsBlocks([REWARDS_PAGE_FAQ], {
        revalidateOnMount: true,
        revalidateOnFocus: false
    })

    const findWidget = () => {
        return document.querySelector('.yotpo-widget-loyalty-page')
    }

    const reInitializeWidget = () => {
        const yotpoWidget = findWidget()

        if (yotpoWidget) {
            window.yotpoWidgetsContainer?.initWidgets()
            yotpoWidget.remove()
        } else if (
            typeof window &&
            window.yotpoWidgetsContainer &&
            typeof window.yotpoWidgetsContainer?.initWidgets === 'function'
        ) {
            window.yotpoWidgetsContainer?.initWidgets()
        }
    }

    useEffect(() => {
        reInitializeWidget()
    }, [toggleYotpoReviewPageWidget])

    return (
        <div className={s['cms-page']}>
            <SEO page={SEO_ENUMS.REWARDS} />
            <div
                className="yotpo-widget-instance"
                data-yotpo-instance-id={props.widgetId}
            />
            <RichContent html={getCMSBlock(REWARDS_PAGE_FAQ, CmsBlocks)} />
        </div>
    )
}

Rewards.Layout = Layout
